import { Lottie } from '@rhg/libs/lottie-react';
import soundBarDark from '@rhg/libs/lottie-react/animations/sound-bar-dark';
import soundBarLight from '@rhg/libs/lottie-react/animations/sound-bar-light';
import { useTheme } from '@rhg/libs/material';

export function PlayingAnimation() {
    const {
        palette: { mode },
    } = useTheme();

    return (
        <Lottie
            autoPlay
            loop
            animationData={mode === 'dark' ? soundBarLight : soundBarDark}
        />
    );
}
